import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import Modal from '../Modal';
import { TextField } from '@mui/material';
import useInputState from '../../../hooks/useInputState';
import { CreateAppDataType } from '../../../pages/Apps';
import { AuthContext } from '../../../Context/auth';
import LocationList, { ListItem, LocationListProps } from './LocationsList';
import { LoaderToggleContext } from '../../../App';
import { getLocations } from '../../../config/squareApi';

type Step1Props = {
  disabled: boolean;
  appId: string;
  handleInputAppId: (e: React.ChangeEvent<HTMLInputElement>) => void;
  token: string;
  handleInputToken: (e: React.ChangeEvent<HTMLInputElement>) => void;
  appName: string;
  handleInputAppName: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const Step1: FunctionComponent<Step1Props> = (props) => {
  const {
    disabled,
    token,
    handleInputToken,
    handleInputAppId,
    appId,
    appName,
    handleInputAppName
  } = props;

  return (
    <>
      <TextField
        disabled={disabled}
        autoFocus
        margin="dense"
        id="app_id"
        label="App ID"
        type="text"
        fullWidth
        variant="standard"
        value={appId}
        onChange={handleInputAppId}
      />
      <TextField
        disabled={disabled}
        autoFocus
        margin="dense"
        id="name"
        label="Square token"
        type="text"
        fullWidth
        variant="standard"
        value={token}
        onChange={handleInputToken}
      />
      <TextField
        autoFocus
        margin="dense"
        id="app_name"
        label="App name"
        type="text"
        fullWidth
        variant="standard"
        value={appName}
        onChange={handleInputAppName}
      />
    </>
  )
}

const Step2: FunctionComponent<LocationListProps & { show: boolean }> = (props) => {
  const {
    show,
    ...ListProps
  } = props;

  return show ? (
    <LocationList
      {...ListProps}
    />
  ) : null;
}

type AddNewAppModalProps = {
  opened: boolean
  handleClose: () => void;
  handleCreate: (data: CreateAppDataType) => void;
}

const AddNewAppModal: FunctionComponent<AddNewAppModalProps> = (props) => {
  const [appName, handleInputAppName] = useInputState('');
  const [appId, handleInputAppId] = useInputState('');
  const [token, handleInputToken] = useInputState('');
  const [selectedLocationId, setSelectedLocationId] = useState<null | string>(null);
  const [locations, setLocations] = useState<ListItem[]>([]);
  const { loadingOn, loadingOff } = useContext(LoaderToggleContext);

  const [step, setStep] = useState(1);

  const { auth } = useContext(AuthContext);

  useEffect(() => {
    console.log(auth?.uid);
  }, []);

  const { handleCreate, ...ModalProps } = props;

  const requestLocations = async () => {
    loadingOn();

    const locationsData = await getLocations();

    console.log('Got location data: ', locationsData);

    setLocations(locationsData);

    loadingOff();
  }

  useEffect(() => {
    if (step === 2) {
      requestLocations();
    }
  }, [step]);

  const onCreate = () => {
    if (
      selectedLocationId &&
      appName &&
      token &&
      appId
    ) {
      handleCreate({
        AppName: appName,
        ApplicationID: appId,
        LocationId: selectedLocationId,
        UserID: auth!.uid,
        UserToken: token
      });
    }
  }

  return (
    <Modal
      {...ModalProps}
      actionName={ step === 1 ? 'next' : 'add'}
      handleAction={ step === 1 ? () => setStep(2) : onCreate}
      cancelActionName={step === 1 ? 'Cancel' : 'Back'}
      handleCancelAction={step === 1 ? ModalProps.handleClose : () => setStep(1)}
      title={'Add new application'}
      text={'Please insert the token received from square into this field'}
      actionDisabled={
        step === 1 ?
          !(appId && token && appName) :
          !(selectedLocationId)
      }
    >
      <Step1
        disabled={step === 2}
        appId={appId}
        handleInputAppId={handleInputAppId}
        token={token}
        handleInputToken={handleInputToken}
        appName={appName}
        handleInputAppName={handleInputAppName}
      />
      <Step2
        show={step === 2}
        locations={locations}
        selectedLocationId={selectedLocationId}
        handleSelect={setSelectedLocationId}
      />

      {/*<TextField*/}
      {/*  autoFocus*/}
      {/*  margin="dense"*/}
      {/*  id="location_id"*/}
      {/*  label="Location ID"*/}
      {/*  type="text"*/}
      {/*  fullWidth*/}
      {/*  variant="standard"*/}
      {/*  value={locationId}*/}
      {/*  onChange={handleInputLocationId}*/}
      {/*/>*/}
    </Modal>
  );
}

export default AddNewAppModal;
